<h2 mat-dialog-title class="dialog-header">
    <div class="header-left">
        <mat-icon class="header-icon">person_add_alt_1</mat-icon>
        USER SUBSTITUTION
    </div>
    <button type="button" aria-label="Close" (click)="cancel()" class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<div class="container">
    <form [formGroup]="substituteForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label for="substituteUser">Substitute User</label>
            <mat-form-field class="full-width">
                <input type="text" matInput [formControl]="substituteUserControl" [matAutocomplete]="auto"
                    placeholder="Search for a user">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onUserSelect($event)">
                    <mat-option *ngFor="let user of filteredUsers | async" [value]="user.emailId">
                        {{ user.fullName }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <div *ngIf="substituteForm?.get('substituteUser')?.touched && substituteForm?.get('substituteUser')?.errors?.['required']">
                <small class="text-danger">Substitute User is required.</small>
            </div>
            <div *ngIf="substituteForm?.get('substituteUser')?.touched && substituteForm?.get('substituteUser')?.errors?.['invalidSubstituteUser']">
                <small class="text-danger">Please select a user from the list.</small>
            </div>
        </div>
        <div class="form-group">
            <label for="startDate">Start Date</label>
            <mat-form-field appearance="fill" class="form-control">
                <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" placeholder="dd/MM/yyyy">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
            <div *ngIf="substituteForm.get('startDate')?.invalid && substituteForm.get('startDate')?.touched" class="text-danger">
                Start Date is required.
            </div>
        </div>
        <div class="form-group">
            <label for="startDate">End Date</label>
            <mat-form-field appearance="fill" class="form-control">
                <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" placeholder="dd/MM/yyyy">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
            <div *ngIf="substituteForm.get('endDate')?.invalid && substituteForm.get('endDate')?.touched" class="text-danger">
                End Date is required.
            </div>
        </div>
        <div class="form-group">
            <label for="comments">Comments</label>
            <textarea id="comments" formControlName="comments" class="form-control" placeholder="Add comments"
                rows="4"></textarea>
            <div *ngIf="substituteForm?.get('comments')?.touched && substituteForm?.get('comments')?.invalid">
                <small class="text-danger">Comments is required.</small>
            </div>
        </div>
        <div style="text-align: center;">
            <div class="box saveUserPrefMsg message-box" *ngIf="message"
                [ngClass]="{ 'success': isSuccess, 'error': !isSuccess }">
                {{ message }}
            </div>
        </div>
        <div class="button-container">
            <button type="submit" class="btn btn-primary save-button" [disabled]="substituteForm.invalid">Save</button>
        </div>
    </form>
</div>